import React from 'react';

export const ArrowFlag = () => (
  <svg width="24" height="12" viewBox="0 0 24 12">
    <path d="M0 12 12 0l12 12z" fill="#F7EDE8" fillRule="evenodd" opacity=".5" />
  </svg>
);
